import { render, staticRenderFns } from "./CompanyInfo.vue?vue&type=template&id=6893c39f&scoped=true"
import script from "./CompanyInfo.vue?vue&type=script&lang=ts"
export * from "./CompanyInfo.vue?vue&type=script&lang=ts"
import style0 from "./CompanyInfo.vue?vue&type=style&index=0&id=6893c39f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6893c39f",
  null
  
)

export default component.exports